<template>
    <div v-if="results.length" class="dd-m-menu__item--bordered">
        <li class="dd-m-menu__item"
            v-for="(item, index) in results" :key="index"
            v-bind:class="{ 'dd-m-menu__item--has-submenu': item.subcategories && item.subcategories.length }">
            <a :href="item.subcategories.length ? '#': `${lang}/categoria/${item.slug}`"
               class="dd-m-menu__link">
                <i v-if="item.icon" class="dd-m-icon icon-"
                   v-bind:class="'icon-'+item.icon"></i>
                <span>{{item.name}}</span>
            </a>

            <div class="dd-m-menu__submenu"
                 v-if="item.subcategories && item.subcategories.length">
                <div class="dd-m-menu__header">
                    <i v-if="item.icon" class="dd-m-icon icon-"
                       v-bind:class="'icon-'+item.icon"></i>
                    <span>{{item.name}}</span>
                </div>

                <ul class="dd-m-menu__submenu__list">
                    <li class="dd-m-menu__item" v-for="(subitem, i) in item.subcategories" :key="i">
                        <a :href="lang + '/categoria/' + item.slug + '/' + subitem.slug" class="dd-m-menu__link">
                            <i v-if="subitem.icon" class="dd-m-icon icon-"
                               v-bind:class="'icon-'+subitem.icon"></i>
                            <span>{{subitem.name}}</span>
                        </a>
                    </li>
                </ul>

                <div class="dd-m-menu__footer">
                    <a class="dd-m-menu__back-btn" href="#" title="">
                        <i class="dd-m-icon icon-back"></i>
                        <span>Back</span>
                    </a>
                </div>
            </div>
        </li>
    </div>
</template>
<script>
    import CategoryService from "../../providers/api/category-service";

    const categoryService = new CategoryService();

    export default {
        name: 'categories',
        data: () => {
            return {
                lang: '',
                results: []
            }
        },
        mounted() {
            this.lang = language !== 'en' ? '/' + language : '';

            categoryService.doGetCategories(true)
                .then((res) => this.results = res.data.data);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/header/categories.vue